module.exports = __webpack_public_path__ + "static/img/tj.a8ed5244.svg";